import type { NavigateFunction, NavigateOptions } from "react-router-dom";

/** Resolve browser-style hrefs, preserving query strings and fragments. */
export function internalHref(href: string): string | null {
  if (!href.trim()) return null;
  try {
    const url = new URL(href, window.location.href);
    if (!['http:', 'https:'].includes(url.protocol) || url.origin !== window.location.origin) return null;
    return url.pathname + url.search + url.hash;
  } catch {
    return null;
  }
}

export function navigateHref(navigate: NavigateFunction, href: string, options?: NavigateOptions): void {
  const path = internalHref(href);
  if (path !== null) navigate(path, options);
  else if (href.trim()) window.location.assign(href);
}

let routerNavigate: NavigateFunction | undefined;
let pendingRedirect: string | undefined;

/** Services may request a redirect before the React bridge has mounted. */
export function redirectTo(path: string): void {
  if (routerNavigate) routerNavigate(path, { replace: true });
  else pendingRedirect = path;
}

export function bindNavigation(navigate: NavigateFunction): () => void {
  routerNavigate = navigate;
  if (pendingRedirect) {
    const path = pendingRedirect;
    pendingRedirect = undefined;
    navigate(path, { replace: true });
  }
  return function () {
    if (routerNavigate === navigate) routerNavigate = undefined;
  };
}
